import { useEffect, useState } from 'react';
import { getAffiliates } from 'src/api/pmApi';
import { apiErrorHandling } from '../api/apierrorhandling';
import { IAffiliate } from '../models';
import { generalStore } from '../stores/GeneralStore';

export const useAffiliates = (partnerId: string | undefined, reload: boolean) => {
  const [affiliates, setAffiliates] = useState<IAffiliate[] | null>(null);
  const load = async (partnerId: string) => {
    generalStore.setIsLoading(true);
    try {
      const response = (await getAffiliates(partnerId)).data;
      setAffiliates(response.data);
    } catch (error: any) {
      apiErrorHandling(error, 'Error loading SPV');
    } finally {
      generalStore.setIsLoading(false);
    }
  };

  useEffect(() => {
    if (partnerId) {
      load(partnerId);
    }
  }, [partnerId, reload]);

  return affiliates;
};
